import { getCleanUrl as e, getJoinUrl as o, getSessionNameFromUrl as r, getSessionPasswordFromUrl as t } from "./utils/urls.js";
import { getUserColor as i } from "./utils/colors.js";
import { deriveNickname as l } from "./utils/users.js";
const a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  deriveNickname: l,
  getCleanUrl: e,
  getJoinUrl: o,
  getSessionNameFromUrl: r,
  getSessionPasswordFromUrl: t,
  getUserColor: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  a as i
};
